import { Link } from "react-router-dom";
import type { Character } from "@/types/content";
import Tag from "@/components/base/Tag";

interface CharacterCardProps {
  character: Character;
}

export default function CharacterCard({ character }: CharacterCardProps) {
  return (
    <Link
      to={`/characters/${character.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer"
    >
      <div className="relative w-full h-56 overflow-hidden">
        <img
          src={character.avatar}
          alt={`${character.name} 角色形象`}
          title={`${character.name} - 美国禁忌4 角色档案`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent" />
        <span className="absolute top-3 left-3">
          <Tag tone={character.type === "反派" ? "accent" : character.type === "主角" ? "primary" : "secondary"}>
            {character.type}
          </Tag>
        </span>
        <div className="absolute bottom-3 left-4 right-4">
          <h3 className="font-heading text-lg text-foreground-950 group-hover:text-accent-400 transition-colors">
            {character.name}
          </h3>
          <p className="font-label text-[10px] tracking-[0.2em] text-accent-400 uppercase mt-0.5">
            {character.enName}
          </p>
        </div>
      </div>
      <div className="flex flex-col flex-1 p-4">
        <p className="text-[13px] text-foreground-500 leading-relaxed line-clamp-3 flex-1">{character.bio}</p>
        <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between">
          <span className="text-xs text-foreground-500 font-label">
            出演 · {character.actor}
          </span>
          <span className="text-xs text-foreground-500 font-label">
            第 {character.seasons.join(" / ")} 季
          </span>
        </div>
      </div>
    </Link>
  );
}